<template>
  <div
    id="failed-to-add-flash-product-to-card-modal"
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        @click="hide"
      />

      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full md:w-10/12 sm:p-6">
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
            <i class="far fa-exclamation-triangle text-red-700 text-xl" />
          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Er is op dit moment geen verbinding met de server van JouwVeilingen.
            </h3>
            <div class="mt-2">
              JouwVeilingen.nl heeft een stabiele internetverbinding nodig om te kunnen functioneren en altijd up to date te zijn.
            </div>

            <div
              v-if="connecting"
              class="mt-2"
            >
              Proberen opnieuw verbinding te maken.
            </div>
            <div
              v-if="unavailable"
              class="mt-2"
            >
              Controleer je internetverbinding en vernieuw de pagina.
            </div>
            <div
              v-if="reinitialized"
              class="mt-2"
            >
              Verbinding hersteld, pagina wordt herladen.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Mixins/Modal';

export default {
  mixins: [Modal],

  props: {
    connecting: {
      type: Boolean,
      required: true,
    },

    unavailable: {
      type: Boolean,
      required: true,
    },

    reinitialized: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
